// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const WindowModalClose: React.FC<{ size?: number; color1?: string; className?: string }> = ({
    size = 10,
    color1 = "#231f20",
    className,
}) => (
    <svg className={className} focusable="false" viewBox="0 0 10 10" width={size} height={size}>
        <path
            fill="currentColor"
            d="M9.155 9.862a.503.503 0 0 0 .707 0 .503.503 0 0 0 0-.707L5.715 5.008 9.862.861a.503.503 0 0 0 0-.707.503.503 0 0 0-.707 0L5.008 4.3.861.154a.503.503 0 0 0-.707 0 .503.503 0 0 0 0 .707L4.3 5.008.154 9.155a.503.503 0 0 0 0 .707.503.503 0 0 0 .707 0l4.147-4.147z"
        />
    </svg>
);

export default React.memo(WindowModalClose);
